/* Copyright (c) 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { PropsWithChildren } from "react";
import { Auth0Client } from "@auth0/auth0-spa-js";
import { useHistory } from "react-router-dom";
import { Auth0Provider } from "./Auth0";
import { AppState } from "./types";

type Auth0ProviderWithHistoryProps = PropsWithChildren<{
  client: Auth0Client;
}>;

export function Auth0ProviderWithHistory({
  children,
  ...props
}: Auth0ProviderWithHistoryProps) {
  const history = useHistory();

  const onRedirectCallback = (appState: AppState) => {
    history.push(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider onRedirectCallback={onRedirectCallback} {...props}>
      {children}
    </Auth0Provider>
  );
}
